import React, { useEffect, useState } from "react";
import "./ListofResign.css";
import axios from "axios";

const ListofResign = () => {
  const [resignations, setResignations] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/resignations`)
      .then((response) => {
        console.log("Resignations fetched:", response.data);
        setResignations(response.data); // ✅ show all records
      })
      .catch((error) => {
        console.error("Error fetching resignations:", error);
      });
  }, []);

  // 🔥 Function called when dropdown changes
  const handleStatusChange = async (event, resignation) => {
    const newStatus = event.target.value;

    if (!newStatus) return;

    try {
      const approvedFlag = newStatus.toUpperCase() === "APPROVED";

      const payload = {
        approved: approvedFlag,
        managerComments: resignation.comment || "",
        status: newStatus.toUpperCase(),
      };

      console.log("Updating resignation:", resignation.id, payload);

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/resignations/${resignation.id}/approval`,
        payload
      );

      // ✅ Update UI locally
      const updatedList = resignations.map((item) =>
        item.id === resignation.id
          ? {
            ...item,
            resignationStatus: newStatus.toUpperCase(),
            managerComment: resignation.comment,
          }
          : item
      );

      setResignations(updatedList);
      alert(`Resignation ${newStatus.toUpperCase()} successfully.`);
    } catch (error) {
      console.error("Error updating resignation:", error);
      alert("Failed to update resignation. Please try again.");
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    if (isNaN(date)) return "Invalid Date";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // ✅ dd-MM-yyyy format
  };

 
  return (
    <div className="resign-table-container">
      <h2>Resignation Approval Form</h2>
      <div style={{ overflowX: "auto" }}>
        <div className="resign-mid-report"> 

           <table className="resign-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Employee Name</th>
              <th>Designation</th>
              <th>Contact</th>
              <th>Client</th>
              <th>Project</th>
              <th>Reason</th>
              <th>Resign Date</th>
              <th>Releaving Request Date</th>
              <th>Manager Comments</th>
              <th>Status / Action</th>
            </tr>
          </thead>
          <tbody>
            {resignations.length === 0 ? (
              <tr>
                <td colSpan="9">No data available</td>
              </tr>
            ) : (
              resignations.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.employeeName}</td>
                  <td>{item.designation || "—"}</td>
                  <td>{item.contactNumber || "—"}</td>
                  <td>{item.client || "—"}</td>
                  <td>{item.project || "—"}</td>
                  <td>{item.reason}</td>
                  <td>{formatDate(item.lastDate)}</td>
                  <td>{formatDate(item.noticePeriodDate)}</td>


                  {/* ✅ Manager Comments column */}
                  <td>
                    {item.resignationStatus === "PENDING" ? (
                      <input
                        type="text"
                        placeholder="Enter comment"
                        value={item.comment || ""}
                        onChange={(e) => {
                          const updated = resignations.map((r) =>
                            r.id === item.id
                              ? { ...r, comment: e.target.value }
                              : r
                          );
                          setResignations(updated);
                        }}
                      />
                    ) : (
                      <span>{item.managerComment || "—"}</span>
                    )}
                  </td>

                  {/* ✅ Dropdown for PENDING, else show status */}
                  <td>
                    {item.resignationStatus === "PENDING" ? (
                      <select
                        defaultValue=""
                        onChange={(e) => handleStatusChange(e, item)}
                      >
                        <option value="" disabled>
                          Select Action
                        </option>
                        <option value="APPROVED" className="edit-option">Approve</option>
                        <option value="REJECTED" className="delete-option">Reject</option>
                      </select>
                    ) : (
                      <span
                        style={{
                          color:
                            item.resignationStatus === "APPROVED" || item.resignationStatus === "DONE"
                              ? "green"
                              : "red",
                          fontWeight: "bold",
                        }}
                      >
                        {item.resignationStatus}
                      </span>
                    )}
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
       
      </div>
    </div>
  );
};

export default ListofResign;
